import type { Adres } from '@/types/domain';

/** "Koestraat 12A-bis" */
export function adresRegel(adres: Adres): string {
  const nummer = [adres.huisnummer, adres.huisletter].filter(Boolean).join('');
  const toevoeging = adres.toevoeging ? `-${adres.toevoeging}` : '';
  return `${adres.straat} ${nummer}${toevoeging}`.trim();
}

/** "Koestraat 12A, 4931 AB Geertruidenberg" */
export function adresVolledig(adres: Adres): string {
  return `${adresRegel(adres)}, ${adres.postcode} ${adres.plaats}`.trim();
}

/** Sorteersleutel: straat alfabetisch, huisnummer numeriek. */
export function adresSorteerSleutel(adres: Adres): string {
  const nr = String(adres.huisnummer ?? '').padStart(6, '0');
  return `${adres.straat.toLowerCase()}|${nr}|${adres.huisletter ?? ''}|${adres.toevoeging ?? ''}`;
}

const datumFormatter = new Intl.DateTimeFormat('nl-NL', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

/** ISO-datum (yyyy-mm-dd of volledige ISO) naar dd-mm-jjjj. */
export function datumNL(iso: string | undefined | null): string {
  if (!iso) return '';
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
  if (Number.isNaN(d.getTime())) return '';
  return datumFormatter.format(d);
}

/** Vandaag als yyyy-mm-dd in lokale tijd (niet UTC). */
export function vandaagISO(): string {
  const d = new Date();
  const maand = String(d.getMonth() + 1).padStart(2, '0');
  const dag = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${maand}-${dag}`;
}

export function getalNL(waarde: number | null | undefined, decimalen = 0): string {
  if (waarde === null || waarde === undefined || Number.isNaN(waarde)) return '';
  return waarde.toLocaleString('nl-NL', {
    minimumFractionDigits: decimalen,
    maximumFractionDigits: decimalen,
  });
}

export function bytesLeesbaar(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} kB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

/** "3 minuten geleden" — voor de autosave-indicator. */
export function relatieveTijd(iso: string): string {
  const verschil = Date.now() - new Date(iso).getTime();
  const sec = Math.round(verschil / 1000);
  if (sec < 10) return 'zojuist';
  if (sec < 60) return `${sec} sec geleden`;
  const min = Math.round(sec / 60);
  if (min < 60) return `${min} min geleden`;
  const uur = Math.round(min / 60);
  if (uur < 24) return `${uur} uur geleden`;
  return datumNL(iso);
}
